import React from "react";
import styled from "styled-components";

const ContactLayout = styled.div`
  background-color: #ffffff;
  min-height: 100vh;
  color: #000000;
  
  svg, a svg {
    fill: #000000!important;
  }
  
  path {
    fill: #000000;
  }

  a {
    color: #000000;
  }

  input, textarea {
    color: #ffffff;
    background-color: #ffffff;
    border: 1px solid #000000;
    &::placeholder {
      color: rgba(0, 0, 0, 0.7);
    }
  }

  /* Estilos específicos para el newsletter */
  [name="newsletter"] {
    input {
      background-color: #ffffff;
      color: #000000;
      border: 1px solid #000000;
      &::placeholder {
        color: rgba(0, 0, 0, 0.7);
      }
    }
  }

`;

const Layout = ({ children }) => {
  return <ContactLayout>{children}</ContactLayout>;
};

export default Layout; 